import { toString } from '@carbon/icon-helpers';

import Undo24 from '@carbon/icons/es/undo/24';
import Redo24 from '@carbon/icons/es/redo/24';
import Cursor_124 from '@carbon/icons/es/cursor--1/24';
import Touch_124 from '@carbon/icons/es/touch--1/24';

const strUndo24 = toString(Undo24);
const strRedo24 = toString(Redo24);
const strCursor24 = toString(Cursor_124);
const strTouch24 = toString(Touch_124);

export { strUndo24, strRedo24, strCursor24, strTouch24 };
